import {
    subYears, subDays, startOfMonth, setHours, parseISO, differenceInMonths,
} from 'date-fns';

const getYesterday = () => {
    const now = new Date();
    return subDays(now, 1).toISOString().split('T')[0];
};

const getDefaultTo = () => {
    const now = new Date();
    const firstOfMonth = setHours(startOfMonth(now), 12);
    const lastOfLastMonth = subDays(firstOfMonth, 1);
    return lastOfLastMonth.toISOString().split('T')[0];
};

const getDefaultFrom = () => {
    const now = new Date();
    const firstOfMonth = setHours(startOfMonth(now), 12);
    const firstOfMonthLastYear = subYears(firstOfMonth, 1);
    return firstOfMonthLastYear.toISOString().split('T')[0];
};

const getGroupingPeriod = (from, to) => {
    const fromDate = parseISO(from);
    const toDate = parseISO(to);

    const monthsDifference = differenceInMonths(toDate, fromDate);

    if (monthsDifference >= 3) {
        return 'MONTH';
    }

    if (monthsDifference >= 1) {
        return 'WEEK';
    }

    return 'DAY';
};

export {
    getYesterday,
    getDefaultTo,
    getDefaultFrom,
    getGroupingPeriod,
};
